import { VStack, HStack, Box, Button } from '@chakra-ui/react';
import { FormattedMessage } from 'react-intl';
import { SegmentBusRoute } from '../../data/useSearchPublicBusData';
import BusRouteStopIcon from '../SitePublicTransport/BusRouteStopIcon';

export default function StepDrawArea({
  isCreating,
  onStartCreating,
  busRoutes,
  routeColors,
}: {
  isCreating: boolean;
  onStartCreating: () => void;
  busRoutes?: SegmentBusRoute[];
  routeColors?: Record<string, string>;
}) {
  return (
    <VStack width="100%" spacing={4} alignItems="stretch">
      {isCreating && (
        <Box>
          <FormattedMessage
            id="ZTblOP"
            defaultMessage="Click on the map to start drawing a new area"
          />
        </Box>
      )}
      <Box>
        <Button
          variant="outline"
          colorScheme="greenDark"
          size="sm"
          onClick={onStartCreating}
          isDisabled={isCreating}
        >
          <FormattedMessage id="yPEBUC" defaultMessage="Reset drawing" />
        </Button>
      </Box>
      {busRoutes && busRoutes.length > 0 && (
        <VStack width="100%" spacing={4} alignItems="stretch">
          <Box fontSize="md" color="gray.500">
            <FormattedMessage
              defaultMessage="Available bus routes in this area:"
              id="khRiYe"
            />
          </Box>
          {Object.entries(
            busRoutes.reduce(
              (acc, busRoute) => {
                const group = busRoute.routeName;
                if (!acc[group]) {
                  acc[group] = [];
                }
                acc[group].push(busRoute);
                return acc;
              },
              {} as Record<string, SegmentBusRoute[]>
            )
          ).map(([group, groupRoutes]) => (
            <VStack spacing={2} key={group} alignItems="stretch">
              <Box fontSize="sm" fontWeight="bold">
                {group}
              </Box>
              {groupRoutes.map((busRoute) => (
                <VStack spacing={0} key={busRoute.routeId} alignItems="stretch">
                  <HStack spacing={2} alignItems="center">
                    <Box>
                      {routeColors && routeColors[busRoute.routeId] && (
                        <BusRouteStopIcon
                          color={routeColors[busRoute.routeId]}
                          stopType="origin"
                          boxSize={24}
                        />
                      )}
                    </Box>
                    <Box
                      fontSize="sm"
                      overflow="hidden"
                      textOverflow="ellipsis"
                    >
                      {
                        busRoute.stops.find(
                          (s) => s.stopId === busRoute.firstStopId
                        )?.stopName
                      }
                    </Box>
                  </HStack>
                  <HStack spacing={2} alignItems="center">
                    {routeColors && routeColors[busRoute.routeId] && (
                      <Box>
                        <BusRouteStopIcon
                          color={routeColors[busRoute.routeId]}
                          stopType="destination"
                          boxSize={24}
                        />
                      </Box>
                    )}
                    <Box
                      fontSize="sm"
                      overflow="hidden"
                      textOverflow="ellipsis"
                    >
                      {
                        busRoute.stops.find(
                          (s) => s.stopId === busRoute.lastStopId
                        )?.stopName
                      }
                    </Box>
                  </HStack>
                </VStack>
              ))}
            </VStack>
          ))}
        </VStack>
      )}
    </VStack>
  );
}
